import { render, staticRenderFns } from "./SharedRideServices.vue?vue&type=template&id=2ed1bfb6"
import script from "./SharedRideServices.vue?vue&type=script&lang=ts"
export * from "./SharedRideServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports